<div class="spinner-wrapper" *ngIf="showLoader">
    <mat-spinner></mat-spinner>
</div>
<div class="container design-wrapper">
    <h2>Designs</h2>
    <hr />
    <div class="breadcrumb">
        <ul class="d-flex align-items-center breadcrumb__list">
            <li routerLink="/home" class="breadcrumb__list__list-item">
                <a class="breadcrumb__list__list-item__link">Home</a>
            </li>
            <li class="breadcrumb__list__list-item">
                <a routerLink="/system" class="breadcrumb__list__list-item__link">System</a>
            </li>
            <li class="breadcrumb__list__list-item">
                <a class="breadcrumb__list__list-item__link">New</a>
            </li>
        </ul>
    </div>

    <div>
      <h3 class="design-wrapper__item__title" style="text-align:center;" >Select a design to add a system to, or create a <a [routerLink]="['/design-form']">new design.</a> </h3>
    </div>

    <form action="">
      <div class="input-wrapper">
          <mat-form-field appearance="fill" class="d-flex search-field">
              <mat-icon>search</mat-icon>
              <input matInput [(ngModel)]="searchDesign" name="search"
                  placeholder="Placeholder" />
          </mat-form-field>
      </div>
  </form>

    <div class="d-flex justify-content-start" style="margin-bottom:40px;">
        <button mat-flat-button color="primary" class="add-new-btn" [routerLink]="['/design-form']">
            New Design
        </button>
    </div>
    <div class="design-wrapper__item" *ngFor="let design of designs | appFilter: searchDesign;">
        <div class="d-flex flex-wrap">
            <div class="flex-grow-1 flex-column d-flex">
                <h2 class="design-wrapper__item__title">{{ design.name }}</h2>
                <br>
                <!--<p class="design-wrapper__item__detail">{{ design.id }}</p> -->
                <div class="mt-auto">
                    <button [routerLink]="['/new-system-design']" [queryParams]="{ id: design.id,editMode:false }"
                        mat-flat-button class="mt-auto me-3 view-design" color="accent">
                        Select Design
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="content-text">
        <h4>
            <strong>HVAC Designer Responsibilities</strong>
        </h4>
        <p>Complete one HVAC Design Report for each system design for a house plan, created for either the specific plan
            configuration(i.e., elevation, option, orientation, & county) of the home to be certified or for a plan that
            is intended to be built with potentially different configurations (i.e., different elevations, options
            amd/or orientations).

            Obtain efficiency features (e.g., window performance, insulation levels, and infiltration rate) from the
            builder or Home Energy Rater.

            Provide the completed HVAC Design Report to the builder or credentialed HVAC contractor and to the Home
            Energy Rater.</p>

        <button mat-flat-button color="primary" class="add-new-btn footer-button" [routerLink]="['/design-form']">
            New Design
        </button>
    </div>


</div>
